import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import i18n from '@/i18n'
import Layout from '../layout.vue'
import List from './list.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/custom-job-filter/management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    permission: ['PERM_JOB_CUSTOM_FIELD', 'PREMIUM_JOB_CUSTOM_FIELD', 'COMPUTED_COMPANY_HAS_CUSTOM_JOB_FILTER'],
    titleI18nKey: 'admin.company.customJobFilter.title',
    menu: {
      get label () {
        return i18n.t('admin.company.customJobFilter.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        permission: ['PERM_JOB_CUSTOM_FIELD', 'PREMIUM_JOB_CUSTOM_FIELD', 'COMPUTED_COMPANY_HAS_CUSTOM_JOB_FILTER'],
        titleI18nKey: 'admin.company.customJobFilter.title'
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isNewPage: true,
        isEditMode: false,
        permission: ['PERM_JOB_CUSTOM_FIELD', 'PREMIUM_JOB_CUSTOM_FIELD', 'COMPUTED_COMPANY_HAS_CUSTOM_JOB_FILTER'],
        titleI18nKey: 'admin.company.customJobFilter.label.addJobFilter'
      }
    },
    {
      path: `${basePath}/edit/:filterId`,
      component: Editor,
      meta: {
        isNewPage: true,
        isEditMode: true,
        permission: ['PERM_JOB_CUSTOM_FIELD', 'PREMIUM_JOB_CUSTOM_FIELD', 'COMPUTED_COMPANY_HAS_CUSTOM_JOB_FILTER'],
        titleI18nKey: 'admin.company.customJobFilter.label.editJobFilter'
      }
    }
  ]
}
